import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "1. What We Collect",
    body: "When you request a trial or book a demo, we collect your name, work email, company name, phone number (demo bookings only), and your preferred contact time. When you use our production service, we process the listing photos, brand assets, and market data you upload.",
  },
  {
    title: "2. How We Use It",
    body: "We use your contact details exclusively to respond to your request, deliver your videos, and manage your subscription. Your uploaded content is used solely to produce your videos. Your content is never used to train AI models, and is never sold or shared with third parties for their marketing.",
  },
  {
    title: "3. Data Security",
    body: "All data is transmitted and stored using end-to-end encryption. Access is restricted to the editors working on your account. We retain uploaded assets only while your subscription is active, unless you ask us to keep them for future projects.",
  },
  {
    title: "4. GDPR & CCPA Compliance",
    body: "We comply with the EU General Data Protection Regulation and the California Consumer Privacy Act. You may request access, correction, export, or deletion of your personal data at any time by emailing privacy@realestatehero360.com. We respond within 30 days.",
  },
  {
    title: "5. Cookies",
    body: "We use essential cookies to keep the site functional and privacy-respecting analytics to understand aggregate usage. No advertising trackers, no cross-site profiling. You can disable non-essential cookies in your browser at any time without losing access to the site.",
  },
  {
    title: "6. Contact",
    body: "Questions about this policy? Email privacy@realestatehero360.com. This policy was last updated in July 2026 and may be updated as our service evolves — material changes will be announced on this page.",
  },
];

export default function PrivacyPage() {
  return (
    <main className="bg-hero-cream pt-[72px]" data-testid="privacy-page">
      <section className="mx-auto max-w-3xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
        <Reveal>
          <span className="inline-block border-2 border-hero-black px-3 py-1 font-display text-sm font-semibold uppercase tracking-[0.3em] text-hero-black">
            Legal
          </span>
          <h1 className="mt-6 font-display text-4xl font-bold uppercase tracking-tight text-hero-black sm:text-5xl">
            Privacy Policy
          </h1>
          <p className="mt-4 text-base text-hero-black/60">Last updated: July 2026</p>
        </Reveal>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-hero-black">{s.title}</h2>
              <p className="mt-3 text-base leading-relaxed text-hero-black/70">{s.body}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
